import { Dispatch } from "redux";
import { CaseFollow, Meta } from "typings";
import { CaseFollows } from "@pacerpro/api";

/////////////////////////////////////////////////
// CASE FOLLOWS CONSTANTS
/////////////////////////////////////////////////

export const LOAD_CASE_FOLLOWS = "LOAD_CASE_FOLLOWS";
export const ADD_CASE_FOLLOW_TO_LIST = "ADD_CASE_FOLLOW_TO_LIST";

/////////////////////////////////////////////////
// CASE FOLLOWS ACTIONS
/////////////////////////////////////////////////

export const loadCaseFollows = ({
  data = [],
  included = [],
  meta,
}: {
  data: CaseFollow[];
  included: any[];
  meta: Meta;
}) => ({
  type: LOAD_CASE_FOLLOWS,
  payload: { data, included, meta },
});

export const addCaseFollowToList = ({
  data,
  included = [],
}: {
  data: CaseFollow;
  included: any[];
}) => ({
  type: ADD_CASE_FOLLOW_TO_LIST,
  payload: { data, included },
});

export const getAllCaseFollows = (options: {
  filter?: { [key: string]: string | undefined };
  include?: string[];
  page?: number;
  size?: number;
}) => async (dispatch: Dispatch) => {
  try {
    const caseFollowsResponse = await CaseFollows.getAll(options);
    dispatch(loadCaseFollows(caseFollowsResponse.data));
  } catch (error) {
    console.error(error);
  }
};

export type CaseFollowAction =
  | {
      type: typeof LOAD_CASE_FOLLOWS;
      payload: {
        data: CaseFollow[];
        included: any[];
        meta: Meta;
      };
    }
  | {
      type: typeof ADD_CASE_FOLLOW_TO_LIST;
      payload: {
        data: CaseFollow;
        included: any[];
      };
    };

/////////////////////////////////////////////////
// CASE FOLLOWS REDUCER
/////////////////////////////////////////////////

export interface CaseFollowState {
  caseFollows: CaseFollow[];
  included: any[];
  meta: Meta;
}

const initialState: CaseFollowState = {
  caseFollows: [],
  included: [],
  meta: {
    recordCount: 0,
    pageCount: 0,
  },
};

export default (state = initialState, action: CaseFollowAction) => {
  switch (action.type) {
    case LOAD_CASE_FOLLOWS: {
      return {
        ...state,
        caseFollows: action.payload.data,
        included: action.payload.included,
        meta: action.payload.meta,
      };
    }
    case ADD_CASE_FOLLOW_TO_LIST: {
      return {
        ...state,
        caseFolllows: state.caseFollows.concat(action.payload.data),
        included: [...state.included, ...action.payload.included],
      };
    }
    default:
      return state;
  }
};
